<template>
  <div class="VisitObject">
    <rich-button
      @click="toSelectVisitObject"
      :light="true"
      :inline="true"
      outline
      class="choose-visit-object"
      >{{ gettext("请选择") }}</rich-button
    >
    <div class="">
      <RecordItem
        v-for="(item, index) in showLists"
        :key="index"
        :data="item"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import RecordItem from '@/pages-v2/Visit/components/RecordItem.vue'
export default {
  data () {
    return {
      visitObject: null
    }
  },
  components: { RecordItem },
  props: {
    value: {
      required: false,
      type: [String, Array, Object]
    }
  },
  watch: {
    value (nVal) {
      this.initValue(nVal)
    }
  },
  computed: {
    ...mapState('visit', [
      'invalidOpportunity'
    ]),
    showLists () {
      const config = []
      const { visitObject } = this
      if (visitObject) {
        config.push({
          key: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
          value: visitObject.visitObjectRoleDesc
        })
        config.push({
          key: this.gettext('姓名'),
          value: visitObject.visitObjectName
        })
        config.push({
          key: this.gettext('电话'),
          value: visitObject.visitObjectPhone
        })
        config.push({
          key: this.$t(
              'FoodB_leads_The_relationship_jkYA' /** 倾向联系时间 */
            ),
          value: visitObject.visitObjectContactTime
        })
        config.push({
          key: this.$t(
              'FoodB_optimization_Stimulate_contact_xSSH' /** 倾向联系方式  */
            ),
          value: visitObject.visitObjectContactMode
        })
      }

      return config
    }
  },
  methods: {
    ...mapMutations('visit', [
      'updateVisitObjectStatus'
    ]),
    toSelectVisitObject () {
      this.$createFullScreenVisitObject({
        $on: {
          confirm: (data = {}) => {
            const [contactTime] = data.contactTime || []
            this.visitObject = {
              visitObjectName: data.name,
              visitObjectPhone: data.phone,
              visitObjectRoleId: data.roleId,
              visitObjectRoleDesc: data.roleDesc,
              visitObjectContactTime:
                contactTime
                && [contactTime.startTime, contactTime.endTime].join('-'),
              visitObjectContactMode:
                data.contactMode && data.contactMode.map(item => item.value).join(';')
            }
            this.change()
          }
        }
      }).show()
    },
    initValue (val = {}) {
      this.visitObject = {
        ...this.visitObject,
        ...val
      }
    },
    getValue () {
      if (this.visitObject) {
        this.updateVisitObjectStatus(1)
        return {
          visitObjectName: this.visitObject.visitObjectName,
          visitObjectPhone: this.visitObject.visitObjectPhone,
          visitObjectRoleId: this.visitObject.visitObjectRoleId
        }
      } else {
        return null
      }
    },
    change () {
      let value = this.getValue()
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.VisitObject {
  .choose-visit-object {
    min-width: 192px;
    line-height: 30px;
    font-size: 28px;
    color: #ff6325;
    background: rgba(252, 145, 83, 0.04);
  }
  .record-item-wrap {
    padding: 24px;
  }
}
</style>
